exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer{background-color:var(--affiliation-registration-header-footer-color);color:var(--affiliation-registration-header-text-color);font-size:12px}.Footer__Wrapper{display:flex;flex-direction:column;align-items:left;justify-content:left;padding:1.5rem}@media (min-width:768px){.Footer__Wrapper{align-items:center;justify-content:center}}.Footer__List{list-style-type:none;display:flex;margin:0;flex-direction:column;padding:1rem 0 0}@media (min-width:768px){.Footer__List{flex-direction:row}}.Footer__Link{cursor:pointer;color:var(--affiliation-registration-header-text-color);padding:0}@media (min-width:768px){.Footer__Link{padding:0 .5rem}}.Footer__Link:hover{color:var(--affiliation-registration-header-text-color);text-decoration:underline}.Footer__Link+.Footer__Link{border-left:none}@media (min-width:768px){.Footer__Link+.Footer__Link{border-left:solid 1px var(--affiliation-registration-header-text-color)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./registration-react/components/Footer/Footer.scss
// module id = 811
// module chunks = 0